// ========= plugin import ======= //
import React, {useState, useEffect, useContext} from 'react'
import Select from 'react-select'
import axios from 'axios'
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

// ========= module import ======== //
import SAISVG from '../../../../../_template/helpers/CommonFunction';

import customStyle from '../../../../../cssModule/custom.module.css';

import { ValidateEmail } from '../../../../component/common/Helper';

// ======== component import ========== //
import ValidationMessage from '../../../../component/common/ValidationMessage';
import ButtonLoader from '../../../../component/common/ButtonLoader';

const AddSystemUserForm = (props) => {

    const { totalSystemUserCount, updatedData } = props;
    const api_base_url = process.env.REACT_APP_API_URL;
    const loginUserType = localStorage.getItem('type');
   
    const roleSelectObject = [
        {value : 'D', label : 'Developer'},
        {value : 'S', label : 'System User'}
    ];
    const [isVisible, setIsVisible] = useState(false);
    // ----- Form close handller ------ //
    const FormCloseHandler = (e) => {
        setIsVisible(false);
    }
    // =========== system user handller =========== //
    const AddSystemUserHandler = (e) => {
        setIsVisible(true);
    }

    // ---------- get product list --------- //
    const [productList, setProductList] = useState([]);
    const [botData, setBotData] = useState([]);
    const getProductList = async () => {
        let apiToken = '';
        if(loginUserType === 'A') {
            apiToken = localStorage.getItem('token')
        } else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        await axios.post(`${api_base_url}admin/get-select-product-list`,{sass_id: localStorage.getItem('sass_id')}, api_headers)
        .then(async (res) => {
           
            if(res.data.status === 'success') {
                var resProductList = res.data.data.product_list;
                const formattedProduct = resProductList.map(product => ({
                    value: product.unique_id,
                    label: product.product_name
                }));
                setProductList(formattedProduct)
            } else if(res.data.status === 'error') {
                toast.error(res.data.message);
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }
    const getAllBot = async() => {
        let apiToken = '';
        if(loginUserType === 'A') {
            apiToken = localStorage.getItem('token')
        } else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        
        await axios.post(`${api_base_url}admin/get-all-bot`, {sass_id: localStorage.getItem('sass_id')}, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                const result = res.data.data.map((item, index) => ({
                    label: item.bot_name,
                    value: item.bot_id
                }));
                setBotData(result);
            } else if(res.data.status === 'error') {
                toast.error(res.data.message);
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }
    useEffect(() => {
        getProductList();
        getAllBot();
    },[])

    // ------------ password shown and hide ------------- //
    const [passwordShown, setPasswordShown] = useState(false);
    const togglePasswordVisibility = () => {
        setPasswordShown(!passwordShown)
    }
    
    const [systemUserFormData, setSystemUserFormData] = useState({
        full_name : "", 
        user_email : "" ,
        assign_product : [],
        assign_agent : [],
        assign_role : [],
        user_name : "",
        password : "",
        allow_data_edit : 'N',
        allow_data_delete : 'N',
        allow_data_add : 'N',
        allow_change_permission : 'N'
    });

    const validateField = (name, value) => {
        
        let error = "";
        if (name === "full_name") {
            if (!value) {
                error = "Full name is required";
            } 
        }
        if(name === 'user_email'){
            if (!value) {
                error = "User email is required";
            }
            else if (!ValidateEmail(value)) {
                error = "Invalid email address";
            }
        }
        // if(name === 'assign_product'){
        //     if (!value || (Array.isArray(value) && value.length === 0)) {
        //         error = "Please select at least one product";
        //     }
        // }
        if(name === 'assign_role'){
            if (!value || (Array.isArray(value) && value.length === 0)) {
                error = "Please select at least one role";
            }
        }
        if(name === 'user_name'){
            if (!value) {
                error = "User name is required";
            }
        }
        if(name === 'password'){
            if (!value) {
                error = "Password is required";
            }
        }
        return error;
    };

    const [addUserFormError, setAddUserFormError] = useState({});

    const inputChangeHandler = (selectedOption, actionMeta) => {
        if (actionMeta?.name) {
            const { name } = actionMeta;
            const fieldError = validateField(name, selectedOption);

            setAddUserFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));

            setSystemUserFormData((prevData) => ({
                ...prevData,
                [name]: selectedOption,
            }));

        } else if (selectedOption?.target) {
            const { name, type, value, checked } = selectedOption.target;
            const inputValue = type === "checkbox" ? (checked ? "Y" : "N") : value;
            const fieldError = validateField(name, inputValue);
            setAddUserFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
            setSystemUserFormData((prevData) => ({
                ...prevData,
                [name]: inputValue,
            }));
        }
    };


    const [systemUserUpdateId , setSystemUserUpdateId] = useState('');
    const [updateUserName, setUpdateUserName] = useState('')

    const [isShowButtonLoader, setIsShowButtonLoader] = useState(false)

    const formSubmitHandler = async (e) => {
        e.preventDefault();
        const newErrors = {};
        for (const key in systemUserFormData) {
            newErrors[key] = validateField(key, systemUserFormData[key]);
        }
        setAddUserFormError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            setIsShowButtonLoader(true)
            let apiToken = '';
            if(loginUserType === 'A') {
                apiToken = localStorage.getItem('token')
            } else if(loginUserType === 'SA') {
                apiToken = localStorage.getItem('systemAdminToken')
            }
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : apiToken
                }
            };

            systemUserFormData.update_id = systemUserUpdateId;
            systemUserFormData.old_user_name = updateUserName;
            systemUserFormData.sass_id = localStorage.getItem('sass_id');
            systemUserFormData.type = loginUserType;
            systemUserFormData.login_user_name = loginUserType == 'SA' ? localStorage.getItem('system_username') : '';
            
            await axios.post(`${api_base_url}admin/add-system-user`, systemUserFormData, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    setSystemUserFormData({
                        full_name : "", 
                        user_email : "" ,
                        assign_product : [],
                        assign_agent : [],
                        assign_role : [],
                        user_name : "",
                        password : "",
                        allow_data_edit : 'N',
                        allow_data_delete : 'N',
                        allow_data_add : 'N',
                        allow_change_permission : 'N'
                    });
                    setAddUserFormError({});
                    toast.success(res.data.message);
                    props.formSubmited()
                    setSystemUserUpdateId('')
                    setUpdateUserName('')
                    setIsVisible(false)
                } else if(res.data.status === 'error') {
                    toast.error(res.data.message);
                }
            })
            .catch((error) => {
                console.error(error);
            })
            setIsShowButtonLoader(false)
        }
    }

    // ---------- set updated data in input --------- //
    useEffect(() => {
        if(Object.keys(updatedData).length > 0){
            const { manage_permission } = updatedData
            var updateAssignProduct = productList.filter(item => updatedData.assign_product.includes(item.value));
            var updateAssignAgent = botData.filter(item => updatedData.assign_agent.includes(item.value));
            var updateAssignRole = roleSelectObject.filter(item => updatedData.user_type.includes(item.value));
            setSystemUserUpdateId(updatedData.unique_id)
            setUpdateUserName(updatedData.username)
            setSystemUserFormData({
                full_name : updatedData.user_full_name, 
                user_email : updatedData.user_email ,
                assign_product : updateAssignProduct,
                assign_agent : updateAssignAgent,
                assign_role : updateAssignRole,
                user_name : updatedData.username,
                password : atob(updatedData.password),
                allow_data_edit : manage_permission.allow_data_edit,
                allow_data_delete : manage_permission.allow_data_delete,
                allow_data_add : manage_permission.allow_data_add,
                allow_change_permission : manage_permission.allow_change_permission
            });
            setAddUserFormError({});
            setIsVisible(true)
        }
    },[updatedData])

    

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className="card card-flush border" id="user_add_card">
                        <div className="card-header py-3">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-gray-800 fs-2">System User</span>
                                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                    Total {totalSystemUserCount} system user are available
                                </span>
                            </h3>
                            {!isVisible ? 
                                <div className="card-toolbar">
                                    <div className="d-flex flex-stack flex-wrap gap-4">
                                        <div className="position-relative my-1 m-w-100">
                                            <SAISVG path="media/icons/duotune/general/gen004.svg" className="svg-icon-muted svg-icon-2 position-absolute top-50 translate-middle-y ms-4" />
                                            <input 
                                                type="text" 
                                                className="form-control ps-12 search-user" placeholder="Search"
                                                onChange={props.onChange}
                                            />
                                        </div>
                                        <div className="d-flex align-items-center fw-bold">
                                            <a 
                                                className="btn btn-dark px-6 add-new-user"
                                                onClick={AddSystemUserHandler}
                                            >
                                                Add System User
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            :''}
                        </div>
                        {isVisible ? 
                            <div 
                                className={`card-body pt-0 ${customStyle.contentBody} ${isVisible ? customStyle.slideDown : customStyle.slideUp}`}>
                                <form onSubmit={formSubmitHandler}>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="mb-10">
                                                <label className="form-label required">
                                                    Full Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control-solid ${addUserFormError.full_name ? 'is-invalid' : ''}`}
                                                    placeholder="Enter full name"
                                                    name='full_name'
                                                    onChange={inputChangeHandler}
                                                    value={systemUserFormData.full_name}
                                                />
                                                {addUserFormError.full_name && <ValidationMessage className='text-danger' message ={addUserFormError.full_name}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-10">
                                                <label className="form-label required">
                                                    System User Email
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control-solid ${addUserFormError.user_email ? 'is-invalid' : ''}`}
                                                    placeholder="Enter email"
                                                    name='user_email'
                                                    onChange={inputChangeHandler}
                                                    value={systemUserFormData.user_email}
                                                />
                                                {addUserFormError.user_email && <ValidationMessage className='text-danger' message ={addUserFormError.user_email}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            {/* <div className="mb-10">
                                                <label className="form-label required">
                                                    Assign Product
                                                </label>
                                                <Select
                                                    className='react-select-styled react-select-solid' 
                                                    classNamePrefix='react-select' 
                                                    options={productList} 
                                                    placeholder='Select product' 
                                                    name='assign_product'
                                                    isClearable
                                                    isMulti
                                                    onChange={inputChangeHandler}
                                                    value={systemUserFormData.assign_product}
                                                />
                                                {addUserFormError.assign_product && <ValidationMessage className='text-danger' message ={addUserFormError.assign_product}/>}
                                            </div> */}
                                            <div className="mb-10">
                                                <label className="form-label required">
                                                    Assign Agent
                                                </label>
                                                <Select
                                                    className='react-select-styled react-select-solid' 
                                                    classNamePrefix='react-select' 
                                                    options={botData} 
                                                    placeholder='Select agent' 
                                                    name='assign_agent'
                                                    isClearable
                                                    isMulti
                                                    onChange={inputChangeHandler}
                                                    value={systemUserFormData.assign_agent}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="mb-10">
                                                <label className="form-label required">
                                                    Assign Role
                                                </label>
                                                <Select
                                                    className='react-select-styled react-select-solid' 
                                                    classNamePrefix='react-select' 
                                                    options={roleSelectObject} 
                                                    placeholder='Select Role' 
                                                    name='assign_role'
                                                    onChange={inputChangeHandler}
                                                    value={systemUserFormData.assign_role}
                                                />
                                                {addUserFormError.assign_role && <ValidationMessage className='text-danger' message ={addUserFormError.assign_role}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-10">
                                                <label className="form-label required">
                                                    Username
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control-solid ${addUserFormError.user_name ? 'is-invalid' : ''}`}
                                                    placeholder="Enter username"
                                                    name='user_name'
                                                    onChange={inputChangeHandler}
                                                    value={systemUserFormData.user_name}
                                                />
                                                {addUserFormError.user_name && <ValidationMessage className='text-danger' message ={addUserFormError.user_name}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-10">
                                                <label className="form-label required">
                                                    Password
                                                </label>
                                                <div className="input-group input-group-solid mb-5">
                                                    <input 
                                                        type="text" 
                                                        className={`form-control ${!passwordShown ? 'inp-secure' : ''} ${addUserFormError.password ? 'is-invalid' : ''}`}
                                                        placeholder="Enter password" 
                                                        name='password'
                                                        onChange={inputChangeHandler}
                                                        value={systemUserFormData.password}
                                                    />
                                                    <span className="input-group-text">
                                                        { !passwordShown && 
                                                            <FontAwesomeIcon 
                                                                icon={faEye} 
                                                                className='fs-4 cursor-pointer'
                                                                onClick={ togglePasswordVisibility }
                                                            />
                                                        }
                                                        { passwordShown && 
                                                            <FontAwesomeIcon 
                                                                icon={faEyeSlash} 
                                                                className='fs-4 cursor-pointer'
                                                                onClick={ togglePasswordVisibility }
                                                            />
                                                        }
                                                    </span>
                                                </div>
                                                {addUserFormError.password && <ValidationMessage className='text-danger' message ={addUserFormError.password}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-4 m-auto">
                                            <div className="mb-2">
                                                <div className="d-flex flex-stack border border-gray-300 border-dashed rounded p-2">
                                                    <label className="form-label mb-0">Allow Data Edit</label>
                                                    <div className="form-check form-switch form-check-custom form-check-solid">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="checkbox" 
                                                            name="allow_data_edit" 
                                                            onChange={inputChangeHandler}
                                                            checked={systemUserFormData.allow_data_edit === 'Y' ? true : false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 m-auto">
                                            <div className="mb-2">
                                                <div className="d-flex flex-stack border border-gray-300 border-dashed rounded p-2">
                                                    <label className="form-label mb-0">Allow Data Delete</label>
                                                    <div className="form-check form-switch form-check-custom form-check-solid">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="checkbox" 
                                                            name="allow_data_delete" 
                                                            onChange={inputChangeHandler}
                                                            checked={systemUserFormData.allow_data_delete === 'Y' ? true : false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 m-auto">
                                            <div className="mb-2">
                                                <div className="d-flex flex-stack border border-gray-300 border-dashed rounded p-2">
                                                    <label className="form-label mb-0">Allow Add New</label>
                                                    <div className="form-check form-switch form-check-custom form-check-solid">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="checkbox" 
                                                            name="allow_data_add" 
                                                            onChange={inputChangeHandler}
                                                            checked={systemUserFormData.allow_data_add === 'Y' ? true : false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 mt-5">
                                            <div className="mb-2">
                                                <div className="d-flex flex-stack border border-gray-300 border-dashed rounded p-2">
                                                    <label className="form-label mb-0">Allow Change Permission</label>
                                                    <div className="form-check form-switch form-check-custom form-check-solid">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="checkbox" 
                                                            name="allow_change_permission"
                                                            onChange={inputChangeHandler}
                                                            checked={systemUserFormData.allow_change_permission === 'Y' ? true : false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-8 text-end mt-5">
                                            <a 
                                                href="#" 
                                                className="btn btn-light me-4" 
                                                onClick={(e) => { e.preventDefault(); FormCloseHandler()}}
                                            >
                                                Close
                                            </a>
                                            <button 
                                                className={`btn btn-dark ${isShowButtonLoader && 'disabled'}`} 
                                                type="submit"
                                            >
                                                {
                                                    isShowButtonLoader ? <ButtonLoader btnHtml='Please wait...' className='me-2'/> : 'Save'
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        :''}
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddSystemUserForm